import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ThankYouPage } from './pages/ThankYouPage';
// Lazy load checkout page
const CheckoutPage = lazy(() => import('./pages/CheckoutPage').then(m => ({
  default: m.CheckoutPage
})));
// Loading fallback
const LoadingFallback = () => <div className="min-h-screen flex items-center justify-center bg-gradient-premium" data-id="element-0">
    <div className="w-12 h-12 border-4 border-cta-primary/30 border-t-cta-primary rounded-full animate-spin" data-id="element-1"></div>
  </div>;
function App() {
  return <Router data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<LandingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/gracias" element={<ThankYouPage data-id="element-7" />} data-id="element-6" />
        <Route path="/checkout" element={<Suspense fallback={<LoadingFallback data-id="element-10" />} data-id="element-9">
              <CheckoutPage data-id="element-11" />
            </Suspense>} data-id="element-8" />
      </Routes>
    </Router>;
}
export { App };